import { CONFIG, SEGMENTS, getFilters, TYPES } from './constants';

/*
  Builds the cube query based on dashboard card configuration
  params (card: objects)
*/
export const getCubeQuery = card => {
  const defaultQuery = {
    measures: ['Reports.count'],
    dimensions: [],
    filters: []
  };
  if (card && card.settings) {
    const activeCards = [
      TYPES.BENEFICIARIES,
      TYPES.DONATIONS,
      TYPES.REPORTING,
      TYPES.DATA,
      TYPES.IMPACTS
    ];

    const defaultMetric =
      TYPES.BENEFICIARIES === card.title ? 'Report Count' : 'Generic';
    const defaultSegment =
      TYPES.BENEFICIARIES === card.title ? 'NPO' : 'Portfolio';

    const {
      settings: {
        metric = defaultMetric,
        segment: segmentSetting = defaultSegment,
        comparisonyear = null,
        catalized = null,
      },
      title: cardType
    } = card;

    if (!activeCards.includes(cardType)) {
      return undefined;
    }
    try {
      const cardMetric = (catalized && metric === 'Total claim') ? 'Total claim Catalized' : metric;
      const { measures, dimensions, filters: configFilters } = CONFIG[cardType][cardMetric];
      const segment = SEGMENTS[segmentSetting].dimensions;
      const filters = getFilters(card.settings, card.title);
      const combineDimensions = [...dimensions, ...segment];
      const combineFilters = [...configFilters, ...filters];
      if (comparisonyear && comparisonyear !== 'None') {
        combineDimensions.push('Reports.year');
      }
      return { measures, dimensions: combineDimensions, filters: combineFilters };
    } catch (ex) {
      return undefined;
    }
  }
  return defaultQuery;
};
